<button class="bg-pp-blue shadow text-white" (click)="toggleAccessibility()">
  <lib-svg-sprite svgID="accessibility"></lib-svg-sprite>
</button>
